import { render, staticRenderFns } from "./BaseCarousel.vue?vue&type=template&id=ae2a5950&scoped=true"
import script from "./BaseCarousel.vue?vue&type=script&lang=js"
export * from "./BaseCarousel.vue?vue&type=script&lang=js"
import style0 from "./BaseCarousel.vue?vue&type=style&index=0&id=ae2a5950&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2a5950",
  null
  
)

export default component.exports